import { Notifications } from 'src/types/notification.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'helpdesk/notifications';

export const getNotifications = async () => await http.get<Notifications>(controller);

export const markNotificationsAsRead = async (notificationId?: string) =>
  await http.put(`${controller}/mark-read?notificationId=${notificationId ?? ''}`);

export const markAllNotificationsAsRead = async () => await http.put(`${controller}/mark-read/all`);
